import React from "react";

import NameInputV2 from "./Molecules/NameInput";
import PhoneInputV2 from "./Molecules/PhoneInput";
import EmailInputV2 from "./Molecules/EmailInput";
import GoalsSelectV2 from "./Molecules/GoalsSelect";
import PromoCodeInputV2 from "./Molecules/PromoCodeInput";

import { ErrorUI } from "@/components/Atoms";
import Divider from "@/components/Atoms/Divider";

import SubmitButton from "./SubmitButton";

import {
  Amount,
  AmountWrapper,
  ButtonWrapper,
  CallbackRequestLinkText,
  CallbackRequestText,
  Currency,
  FormBox,
  PersonalDetails,
} from "./style";
import FormWrapper from "../FormWrapper";
import GiftPackCard from "../GiftPackCard";

const Form = ({
  isLoading,
  success,
  error,
  //
  onSubmitCallback = () => {},
  //
  showLabels = true,
  //
  showNameField = true,
  namePlaceholder = "Full Name",
  //
  showPhoneField = true,
  mobilePlaceholder = "Phone Number",
  //
  showEmailField,
  emailPlaceholder = "Email Address",
  //
  showGoalField = true,
  goalOptions = [],
  goalPlaceholder = "Current health condition",
  //
  showPromoCodeField,
  promoCodePlaceholder = "Enter discount code (Optional)",
  promoCodeError,
  promoCodeButtonText,
  handlePromoCodeChange,
  removeAppliedPromoCode,
  promoCodeChecking,
  isPromoCodeApplied,
  applyPromoCode,
  //
  isGift,
  setIsGift,
  handleSubmit,
  control,
  handleBlur,
  pricing,
  handleCallbackFormView,
  showGiftSection,
  ...rest
}) => {
  const NameField = ({ name }) =>
    showNameField && (
      <NameInputV2
        name={name}
        control={control}
        showLabels={showLabels}
        namePlaceholder={namePlaceholder}
        inputFontSize="14px"
        inputLineHeight="24px"
        handleBlur={handleBlur}
        variant="v2"
        iconDimension="16px"
        icon="icon-user-face-2"
      />
    );

  const PhoneField = ({ name }) =>
    showPhoneField && (
      <PhoneInputV2
        control={control}
        name={name}
        showLabels={showLabels}
        mobilePlaceholder={mobilePlaceholder}
        inputFontSize="14px"
        inputLineHeight="24px"
        showPhoneIcon
        handleBlur={handleBlur}
      />
    );

  const EmailField = ({ name }) =>
    showEmailField && (
      <EmailInputV2
        control={control}
        name={name}
        showLabels={showLabels}
        emailPlaceholder={emailPlaceholder}
        inputFontSize="14px"
        inputLineHeight="24px"
        handleBlur={handleBlur}
      />
    );

  const GoalsField = ({ name }) =>
    showGoalField && (
      <GoalsSelectV2
        name={name}
        control={control}
        goalPlaceholder={goalPlaceholder}
        goalOptions={goalOptions}
        fontSize="14px"
        handleBlur={handleBlur}
        removeAppliedPromoCode={removeAppliedPromoCode}
      />
    );

  const PromoCodeField = ({ name }) =>
    showPromoCodeField && (
      <PromoCodeInputV2
        name={name}
        control={control}
        showLabels={showLabels}
        promoCodePlaceholder={promoCodePlaceholder}
        promoCodeError={promoCodeError}
        promoCodeButtonText={promoCodeButtonText}
        isPromoCodeApplied={isPromoCodeApplied}
        promoCodeChecking={promoCodeChecking}
        applyPromoCode={applyPromoCode}
        handlePromoCodeChange={handlePromoCodeChange}
        removeAppliedPromoCode={removeAppliedPromoCode}
        inputFontSize="14px"
        inputLineHeight="24px"
      />
    );

  const SubmitError = !success && error && (
    <ErrorUI error={error} isNotAbsolute mb="8px" />
  );

  const Button = (
    <ButtonWrapper>
      <SubmitButton type="submit" isLoading={isLoading}>
        Buy now
      </SubmitButton>
      <AmountWrapper>
        <Currency variant="paragraph4">
          {pricing?.currency_code || "INR"}.
        </Currency>
        <Amount variant="paragraph4">{pricing?.price || 0}</Amount>
      </AmountWrapper>
    </ButtonWrapper>
  );

  const HorizontalRule = <Divider />;

  const EnterDetails = (
    <PersonalDetails variant="heading6">Enter your details</PersonalDetails>
  );

  const RequestCallback = (
    <CallbackRequestText variant="paragraph1">
      Need more information?{" "}
      <CallbackRequestLinkText variant="span" onClick={handleCallbackFormView}>
        Request a callback.
      </CallbackRequestLinkText>
    </CallbackRequestText>
  );

  const Component = (
    <>
      {NameField({ name: "name" })}
      {PhoneField({ name: "mobile" })}
      {EmailField({ name: "email" })}
      {GoalsField({ name: "goal" })}
      {showGiftSection && isGift && (
        <>
          {HorizontalRule}
          {EnterDetails}
          {NameField({ name: "donorName" })}
          {PhoneField({ name: "donorMobile" })}
          {EmailField({ name: "donorEmail" })}
        </>
      )}
      {PromoCodeField({ name: "promoCode" })}
      {SubmitError}
      {Button}
    </>
  );

  return (
    <>
      <FormWrapper {...rest}>
        {showGiftSection && (
          <GiftPackCard isGift={isGift} setIsGift={setIsGift} />
        )}
        <FormBox onSubmit={handleSubmit(() => onSubmitCallback(false))}>
          {Component}
        </FormBox>
      </FormWrapper>
      {RequestCallback}
    </>
  );
};

export default Form;
